import React from "react";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import classNames from "classnames";

const getClassNames = (buttonStyle, size, classes) => {
  return classNames(
    "btn",
    {
      "btn-primary": buttonStyle === "fill",
      "btn-outline": buttonStyle === "outline",
      "btn-negative": buttonStyle === "negative",
      "btn-sm": size === "sm",
      "btn-base": size === "base",
      "btn-lg": size === "lg",
      "btn-xl": size === "xl",
      "btn-2xl": size === "2xl",
    },
    classes
  );
};

export default function Link({
  to,
  text,
  isButton,
  buttonStyle,
  buttonSize,
  children,
  className,
  currentPath,
  ...props
}) {
  //buttonStyle can be fill, outline or negative
  //butonSize can be sm, base, lg, xl, or 2xl

  const classes = isButton
    ? getClassNames(buttonStyle, buttonSize, className)
    : className;

  /* Scenarios...
  {currentPath = /account/installs/fastvue-syslog/windows/ }
  /account/installs/fastvue-syslog/windows/ > links to https://external.page.com
  /account/installs/fastvue-syslog/windows/ > links to /account/downloads
  /account/installs/fastvue-syslog/windows/ > links to /#anchor-headingA
  /account/installs/fastvue-syslog/windows/ > links to /other/page/#anchor-headingA
  /account/installs/fastvue-syslog/windows/ > links to / (home page)
  */

  //if 'to' is an external link, use a normal <a> and open a new tab
  if (
    to.startsWith("http://") ||
    to.startsWith("https://") ||
    to.startsWith("mailto:")
  ) {
    return (
      <a href={to} alt={text} className={classes} target="_blank" {...props} rel="noreferrer">
        {children}
      </a>
    );
  }

  // if to contains # then work out if its an anchor link on the same page, or different page
  if (to.includes("#")) {
    if (to.startsWith("/#") || to.startsWith("#")) {
      to = currentPath + to;
    }
  }

  return (
    <AnchorLink to={`${to}`} title={text} className={classes} {...props}>
      {children}
    </AnchorLink>
  );
}
